module.exports = __webpack_public_path__ + "static/media/Clarity.20e96409.svg";